import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Logo } from './Logo';
import { NotificationBell } from './NotificationBell';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

export function Header() {
  const { user } = useAuth();

  return (
    <header className="navbar">
      <div className="navbar-left">
        <Link to={user ? '/' : '/login'} className="navbar-brand">
          <Logo size={28} />
          <span>VietSurvive</span>
        </Link>
      </div>

      <div className="navbar-right">
        {user && (
          <nav className="navbar-nav">
            <NavLink to="/support" className={({ isActive }) => `nav-link${isActive ? ' is-active' : ''}`}>
              Support
            </NavLink>
            {user.isAdmin && (
              <NavLink to="/admin/plans" className={({ isActive }) => `nav-link${isActive ? ' is-active' : ''}`}>
                Admin
              </NavLink>
            )}
          </nav>
        )}
        {user && <NotificationBell />}
        <ThemeToggle />
        {user && <UserMenu />}
      </div>
    </header>
  );
}
